import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';

import { VOCCourseModel } from 'src/app/core/VOCCourseModel';

import { AdminService } from 'src/app/services/admin/admin.service';

import {
  FileUploadService
} from 'src/app/services/file-upload/file-upload.service';

import {
  VOCCourseDetailsUnitModel,
  VOCCoursePublicModel
} from '../admin-voc-course-detail/admin-voc-course-detail.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-voc-course',
  templateUrl: './voc-course.component.html',
  styleUrl: './voc-course.component.scss'
})
export class VocCourseComponent
  implements OnInit, OnDestroy, AfterViewInit {

  // Store VOC form file input reference
  @ViewChild('vocFormFileInput')
  vocFormFileInput?: ElementRef<HTMLInputElement>;

  // Store assessment slider reference
  @ViewChild('assessmentSlider')
  assessmentSlider!: ElementRef<HTMLDivElement>;

  // Control previous assessment button
  showAssessmentPreviousButton = false;

  // Control next assessment button
  showAssessmentNextButton = false;


  // Update assessment buttons after view loads
  ngAfterViewInit(): void {

    setTimeout(() => {

      this.updateAssessmentButtons();

    });
  }


  // Store VOC public assessments
  vocAssessments: VOCCoursePublicModel[] = [];

  // Store selected assessment
  selectedAssessment: VOCCoursePublicModel | null = null;

  // Control details popup visibility
  isDetailsPopupOpen = false;

  // Track loading state
  isLoading = false;

  // Store current page number
  pageNo = 1;

  // Store page size
  pageSize = 100;

  // Store total record count
  totalRecords = 0;


  // Track VOC file upload state
  isVocFileUploading = false;

  // Store VOC file error message
  vocFileErrorMessage = '';

  // Store selected VOC file
  selectedVocFile: File | null = null;

  // Store selected VOC file name
  selectedVocFileName = '';

  // Store VOC email address
  vocEmailAddress = '';

  // Store form URL
  formUrl = '';

  // Store success message
  successMessage = '';

  // Store error message
  errorMessage = '';

  // Track upload state
  isUploading = false;

  // Store VOC course model
  VOCCourseModel: VOCCourseModel = {
    id: 0,
    jobNumber: '',
    requestFormUrl: '',
    clientEmail: '',
    paymentStatus: '',
    createdDate: null,
    isReminderSend: false,
    reminderSendOn: null,
    StripePaymentIntentId: '',
    modifedDate: null,
    courseFee: 0
  };


  constructor(
    private adminService: AdminService,
    private uploadService: FileUploadService,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }


  // Initialise VOC page
  ngOnInit(): void {

    // Set VOC query parameter
    /* this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: {
          type: 'VOC'
        },
        queryParamsHandling: 'merge'
      }
    ); */
  }


  // Reset body overflow
  ngOnDestroy(): void {

    document.body.style.overflow = '';
  }

  /* ============================================================
     RETRIEVE VOC PUBLIC COURSES
     ============================================================ */

  getVOCAssessments(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.adminService
      .getVOCCoursePublicList(
        'GET_ACTIVE',
        this.pageNo,
        this.pageSize
      )
      .subscribe({
        next: response => {
          this.vocAssessments =
            response?.records || [];

          this.totalRecords =
            response?.totalRecords || 0;

          this.isLoading = false;
        },
        error: error => {
          console.error(
            'Unable to load VOC assessments:',
            error
          );

          this.isLoading = false;

          this.errorMessage =
            error?.error?.message ||
            'Unable to load VOC assessments.';
        }
      });
  }

  /* ============================================================
     VOC COURSE DETAILS POPUP
     ============================================================ */

  openAssessmentDetails(
    assessment: VOCCoursePublicModel
  ): void {
    this.selectedAssessment = assessment;
    this.isDetailsPopupOpen = true;

    document.body.style.overflow = 'hidden';
  }
  // Close assessment details
  closeAssessmentDetails(): void {

    // Hide details popup
    this.isDetailsPopupOpen = false;

    // Clear selected assessment
    this.selectedAssessment = null;

    // Reset body overflow
    document.body.style.overflow = '';
  }


  // Track VOC assessment
  trackByVocAssessment(
    index: number,
    assessment: VOCCoursePublicModel
  ): number {

    return assessment.id;
  }


  // Track assessment unit
  trackByUnit(
    index: number,
    unit: VOCCourseDetailsUnitModel
  ): number {

    return unit.id || index;
  }

  /* ============================================================
     VOC FILE SELECTION
     ============================================================ */

  onVocFileSelected(event: Event): void {
    const input =
      event.target as HTMLInputElement;

    const file =
      input.files?.[0];

    this.vocFileErrorMessage = '';

    if (!file) {
      this.resetVocFile();
      return;
    }

    if (
      file.type !== 'application/pdf' &&
      !file.name.toLowerCase().endsWith('.pdf')
    ) {
      this.vocFileErrorMessage =
        'Please select a valid PDF file.';

      input.value = '';

      this.selectedVocFile = null;
      this.selectedVocFileName = '';

      return;
    }

    const maximumFileSize =
      10 * 1024 * 1024;

    if (file.size > maximumFileSize) {
      this.vocFileErrorMessage =
        'The PDF file must be smaller than 10 MB.';

      input.value = '';

      this.selectedVocFile = null;
      this.selectedVocFileName = '';

      return;
    }

    this.selectedVocFile = file;
    this.selectedVocFileName = file.name;
    this.isVocFileUploading = true;
    this.formUrl = '';

    this.uploadService
      .uploadSingleFile(
        file,
        'VOC-form'
      )
      .subscribe({
        next: response => {
          this.isVocFileUploading = false;

          const uploadedUrl =
            response?.publicUrl || '';

          if (!uploadedUrl) {
            this.vocFileErrorMessage =
              'The PDF was uploaded, but the file URL was not returned.';

            return;
          }

          this.formUrl = uploadedUrl;
        },
        error: error => {
          console.error(
            'VOC form upload failed:',
            error
          );

          this.isVocFileUploading = false;

          this.vocFileErrorMessage =
            'PDF upload failed. Please try again.';

          this.formUrl = '';
          this.selectedVocFile = null;
          this.selectedVocFileName = '';

          input.value = '';
        }
      });
  }
  // Remove selected VOC file
  removeVocFile(): void {

    // Reset selected VOC file
    this.selectedVocFile = null;

    // Reset selected file name
    this.selectedVocFileName = '';

    // Reset form URL
    this.formUrl = '';

    // Reset file error message
    this.vocFileErrorMessage = '';

    // Reset upload state
    this.isVocFileUploading = false;

    // Clear file input
    if (this.vocFormFileInput) {
      this.vocFormFileInput.nativeElement.value = '';
    }
  }


  // Reset selected VOC file
  private resetVocFile(): void {

    // Reset selected VOC file
    this.selectedVocFile = null;

    // Reset selected file name
    this.selectedVocFileName = '';

    // Reset form URL
    this.formUrl = '';

    // Reset file error message
    this.vocFileErrorMessage = '';

    // Reset upload state
    this.isVocFileUploading = false;

    // Clear file input
    if (this.vocFormFileInput) {
      this.vocFormFileInput.nativeElement.value = '';
    }
  }

  /* ============================================================
     SAVE VOC FORM
     ============================================================ */

  uploadVocForm(): void {
    this.successMessage = '';
    this.errorMessage = '';

    if (
      !this.formUrl ||
      !this.vocEmailAddress.trim()
    ) {
      this.errorMessage =
        'Please enter your email address and upload the form.';

      return;
    }

    this.isUploading = true;

    this.VOCCourseModel.clientEmail =
      this.vocEmailAddress.trim();

    this.VOCCourseModel.requestFormUrl =
      this.formUrl;

    this.VOCCourseModel.createdDate = null;

    this.VOCCourseModel.reminderSendOn = null;

    this.VOCCourseModel.modifedDate = null;

    this.adminService
      .saveVocForm(
        this.VOCCourseModel,
        'INSERT'
      )
      .subscribe({
        next: response => {
          this.isUploading = false;

          if (response?.isSuccess) {
            this.successMessage =
              response.message ||
              'VOC form uploaded successfully.';

            this.vocEmailAddress = '';
            this.formUrl = '';

            this.VOCCourseModel = {
              id: 0,
              jobNumber: '',
              requestFormUrl: '',
              clientEmail: '',
              paymentStatus: '',
              createdDate: null,
              isReminderSend: false,
              reminderSendOn: null,
              StripePaymentIntentId: '',
              modifedDate: null,
              courseFee: 0
            };
          } else {
            this.errorMessage =
              response?.message ||
              'Unable to upload the VOC form.';
          }
        },
        error: error => {
          this.isUploading = false;

          this.errorMessage =
            error?.error?.message ||
            'An error occurred while uploading the VOC form.';
        }
      });
  }

  scrollAssessments(direction: 'left' | 'right'): void {
    const slider = this.assessmentSlider?.nativeElement;

    if (!slider) {
      return;
    }

    const firstCard = slider.querySelector(
      '.ecb-web-voc-assessment-slide'
    ) as HTMLElement | null;

    if (!firstCard) {
      return;
    }

    const sliderStyles = window.getComputedStyle(slider);

    const gap =
      parseFloat(sliderStyles.columnGap || sliderStyles.gap) || 16;

    const scrollAmount = firstCard.offsetWidth + gap;

    slider.scrollBy({
      left: direction === 'right'
        ? scrollAmount
        : -scrollAmount,
      behavior: 'smooth'
    });

    // Check again after smooth scrolling
    setTimeout(() => {
      this.updateAssessmentButtons();
    }, 400);
  }

  //update Assessment Buttons

  updateAssessmentButtons(): void {
    const slider = this.assessmentSlider?.nativeElement;

    if (!slider) {
      return;
    }

    const tolerance = 10;

    const currentScrollPosition = Math.abs(slider.scrollLeft);

    const maximumScrollPosition =
      slider.scrollWidth - slider.clientWidth;

    // Hide left button when near the beginning
    this.showAssessmentPreviousButton =
      currentScrollPosition > tolerance;

    // Hide right button when near the end
    this.showAssessmentNextButton =
      currentScrollPosition <
      maximumScrollPosition - tolerance;
  }
  // Handle window resize
  @HostListener('window:resize')
  onWindowResize(): void {

    // Update assessment buttons
    this.updateAssessmentButtons();
  }


  // Remove HTML tags
  stripHtmlTags(content: string | null | undefined): string {

    // Check content value
    if (!content) {
      return '';
    }

    // Create temporary element
    const temporaryElement =
      document.createElement('div');

    // Set HTML content
    temporaryElement.innerHTML =
      content;

    // Return plain text
    return (
      temporaryElement.textContent ||
      temporaryElement.innerText ||
      ''
    )
      .replace(/\s+/g, ' ')
      .trim();
  }


  // Check content length
  isContentLong(
    content: string | null | undefined,
    maximumLength: number = 30
  ): boolean {

    return this.stripHtmlTags(content).length >
      maximumLength;
  }


  // Get content preview
  getContentPreview(
    content: string | null | undefined,
    maximumLength: number = 30
  ): string {

    // Store plain text content
    const plainTextContent =
      this.stripHtmlTags(content);

    // Return full content when short enough
    if (plainTextContent.length <= maximumLength) {
      return plainTextContent;
    }

    // Return shortened content
    return plainTextContent
      .substring(
        0,
        maximumLength
      )
      .trim();
  }
}